export default class GenericQRCaster {
    pairingURL: string = '';
    wifiSSID: string = '';
    castDeviceName: string = '';
    wifiPassword: string = '';
    wifiEncryptionType: string = '';
    castDeviceInput: string = '';
    rebootCastDevice: string = '';
}
